import * as React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import Bills from "./Bills";

const BillPostingModal = ({ billingRequestPayload, onClose, onPostSuccess }) => {
  return (
    <Dialog
      onClose={onClose}
      title={"Add Billing Request"}
      className="batch-posting-dialog dialog-xxxl">
      <Bills
        isDialog={true}
        onClose={onClose}
        onPostSuccess={onPostSuccess}
        billingRequestPayload={billingRequestPayload}
        component="BillRequest"
      />
    </Dialog>
  );
};

export default BillPostingModal;
